// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_wrapper__qinay {
  position: relative;
  width: 100%;
  padding-bottom: 18px;
  text-align: center;
}
.styles_wrapper__qinay:before {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 0;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 2px;
}
@media (max-width: 576px) {
  .styles_wrapper__qinay {
    padding-bottom: 14px;
  }
}

.styles_wrapperActive__eRAIu:before {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 0;
  border: 1px solid #ff136d;
  border-radius: 2px;
}

.styles_button__7j24G {
  cursor: pointer;
  font-weight: 400;
  font-size: 20px;
  line-height: 25px;
  text-align: center;
  color: rgba(255, 255, 255, 0.8);
  letter-spacing: -0.015em;
  text-transform: uppercase;
  background: none;
  border: none;
  outline: none;
}
@media (max-width: 1200px) {
  .styles_button__7j24G {
    font-size: 16px;
    line-height: 20px;
  }
}

.styles_buttonActive__uqJDM {
  color: #ffffff;
}`, "",{"version":3,"sources":["webpack://./src/components/pageNav/pageNavItem/styles.module.scss","webpack://./src/assets/styles/mixin/breakpoints.scss","webpack://./src/assets/styles/variables/colors.scss"],"names":[],"mappings":"AAGA;EACE,kBAAA;EACA,WAAA;EAEA,oBAAA;EACA,kBAAA;AAHF;AAKE;EACE,WAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,SAAA;EACA,0CAAA;EACA,kBAAA;AAHJ;ACsBE;EDlCF;IAoBI,oBAAA;EAJF;AACF;;AAOA;EACE,WAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,SAAA;EACA,yBAAA;EACA,kBAAA;AAJF;;AAOA;EACE,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,+BEpCS;EFqCT,wBAAA;EACA,yBAAA;EACA,gBAAA;EACA,YAAA;EACA,aAAA;AAJF;AC1BE;EDmBF;IAcI,eAAA;IACA,iBAAA;EAHF;AACF;;AAMA;EACE,cE1DM;AFuDR","sourcesContent":["@import './src/assets/styles/variables/colors';\n@import './src/assets/styles/mixin/breakpoints';\n\n.wrapper {\n  position: relative;\n  width: 100%;\n  //max-width: 200px;\n  padding-bottom: 18px;\n  text-align: center;\n\n  &:before {\n    content: '';\n    position: absolute;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    height: 0;\n    border: 1px solid $white-10;\n    border-radius: 2px;\n  }\n\n  @include sm {\n    //max-width: 97px;\n    padding-bottom: 14px;\n  }\n}\n\n.wrapperActive:before {\n  content: '';\n  position: absolute;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  height: 0;\n  border: 1px solid $pink;\n  border-radius: 2px;\n}\n\n.button {\n  cursor: pointer;\n  font-weight: 400;\n  font-size: 20px;\n  line-height: 25px;\n  text-align: center;\n  color: $white-80;\n  letter-spacing: -0.015em;\n  text-transform: uppercase;\n  background: none;\n  border: none;\n  outline: none;\n\n  @include xl {\n    font-size: 16px;\n    line-height: 20px;\n  }\n}\n\n.buttonActive {\n  color: $white;\n}\n","@mixin xxxxl {\n  @media (max-width: 1920px) {\n    @content;\n  }\n}\n\n@mixin xxxl {\n  @media (max-width: 1700px) {\n    @content;\n  }\n}\n\n@mixin xxl {\n  @media (max-width: 1400px) {\n    @content;\n  }\n}\n\n@mixin xl {\n  @media (max-width: 1200px) {\n    @content;\n  }\n}\n\n@mixin lg {\n  @media (max-width: 992px) {\n    @content;\n  }\n}\n\n@mixin md {\n  @media (max-width: 768px) {\n    @content;\n  }\n}\n\n@mixin sm {\n  @media (max-width: 576px) {\n    @content;\n  }\n}\n","$white: #ffffff;\n$white-3: rgba($white, 0.03);\n$white-4: rgba($white, 0.04);\n$white-5: rgba($white, 0.05);\n$white-10: rgba($white, 0.1);\n$white-30: rgba($white, 0.3);\n$white-50: rgba($white, 0.5);\n$white-70: rgba($white, 0.7);\n$white-80: rgba($white, 0.8);\n$white-90: rgba($white, 0.9);\n$pink: #ff136d;\n$pink-10: rgba($pink, 0.1);\n$pink-15: rgba($pink, 0.15);\n$black: #000000;\n$black-5: rgba($black, 0.05);\n$black-15: rgba($black, 0.15);\n$black-26: rgba($black, 0.26);\n$black-30: rgba($black, 0.3);\n$black-70: rgba($black, 0.7);\n$black-87: rgba($black, 0.87);\n$black-bg: #100f0f;\n$black-nav-bg: #080808;\n$black-footer: #0a0a0a;\n$blue: #443de9;\n$blue-btn: #453fd6;\n$blue-btn-15: rgba($blue-btn, 0.15);\n$blue-btn-40: rgba($blue-btn, 0.4);\n$grey-nav: #b6b6b6;\n$grey-input: #414141;\n$orange: #f5b300;\n$orange-5: rgba($orange, 0.05);\n$green: #12bc56;\n$red: #d33030;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `styles_wrapper__qinay`,
	"wrapperActive": `styles_wrapperActive__eRAIu`,
	"button": `styles_button__7j24G`,
	"buttonActive": `styles_buttonActive__uqJDM`
};
export default ___CSS_LOADER_EXPORT___;
